export default __webpack_public_path__ + "images/neutral.9e70261c1ead484cd8d894f863f0c6a8.svg";